import { Button, Flex, Icon } from '@amigoapp/doca-react';

const ActionsBar = ({
	fileInputRef,
	isAudioEnabled,
	isVideoEnabled,
	isSubmittingFile,
	isSwitchDeviceEnabled,
	onSwitchCameraClick,
	onAudioClick,
	onVideoClick,
	onSelectFiles
}) => (
	<Flex className="doca-bg-white doca-py-4" gap={5} justify="center">
		<Button rounded variant={isAudioEnabled ? 'secondary' : 'danger'} onClick={onAudioClick}>
			<Icon name={isAudioEnabled ? 'microphone' : 'microphone-slash'} />
		</Button>
		<Button rounded variant={isVideoEnabled ? 'secondary' : 'danger'} onClick={onVideoClick}>
			<Icon name={isVideoEnabled ? 'video' : 'video-slash'} />
		</Button>
		<Button rounded disabled={!isSwitchDeviceEnabled || !isVideoEnabled} variant="secondary" onClick={onSwitchCameraClick}>
			<Icon name="camera-rotate" />
		</Button>
		<Button rounded loading={isSubmittingFile} variant="secondary" onClick={() => fileInputRef.current.click()}>
			<Icon name="paperclip-vertical" />
			<input ref={fileInputRef} multiple className="hidden-input" name="upload" type="file" onChange={onSelectFiles} />
		</Button>
	</Flex>
);

export default ActionsBar;
